import React, { Component } from 'react';
import { Container, Row, Col, Button, Label } from 'reactstrap';
import { withStyles, Card } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';

class InvalidObject extends Component{

    /**Return invalid email information popup*/
    render(){
        const { classes, message } = this.props;
    	return(
            <div className={classes.popup_background}>
                <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    <div className="submit-form" style={{ borderRadius: "5px"}}>
                        <Row>
                            <Label style={{fontWeight: "bold", textAlign: "center"}}>{message}</Label>
                        </Row>
                        <br/>
                        <Row style={{ flex: "0 1 auto" }} noGutters>
                            <center>
                                <Button onClick={this.props.cancelPopup} outline color="success" style={{ marginTop: "0.2em", width: "6em"}}>OK</Button>
                            </center>
                        </Row>
                    </div>
                </div>
            </div>
    	);
    }
}
export default withStyles(Constants.styles)(InvalidObject);